import React, { useEffect, useState, useRef } from "react";
import HeaderLandingPage from "../../components/HeaderLandingPage";
import "./landing-page.scss";
import { formatBRL, formatBRLInput, limparMoeda } from "../../utils/Utils";
import FooterLandingPage from "../../components/FooterLandingPage";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import { useHistory, useParams } from "react-router-dom";
import { get } from "../../crud/landing-page.crud";
import Swal from "sweetalert2";

export default function LandingPagePage() {
    const videoRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [valor, setValor] = useState(formatBRL(800));
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    const { slug } = useParams();

    const history = useHistory();

    useEffect(() => {
        if (!slug) {
            return setLoading(false);
        }

        setLoading(true);

        get(slug)
            .then((res) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err) => Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"));
    }, [slug]);

    const playVideo = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }

        setIsPlaying(!isPlaying);
    };

    const calculoFatura = () => {
        const aux = limparMoeda(valor);

        return formatBRL(aux * 0.15);
    };

    const valorDesconto = (e) => {
        const valor_limpo = limparMoeda(e.target.value);

        let aux = e.target.value;

        if (valor_limpo > 999999999.99) {
            aux = 999999999.99;
        }

        e.target.value = aux;

        setValor(formatBRLInput(e).target.value);
    };

    return (
        <BetterCircularProgress loading={loading} style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="container-fluid" style={{ minHeight: "100vh", padding: "0px" }}>
                <HeaderLandingPage data={data} />

                <div className="container-sub-header">
                    <div className="blur-1" style={{ backgroundColor: data?.plp_cor_principal ?? "#4979D1" }} />

                    <div className="blur-2" style={{ backgroundColor: data?.plp_cor_secundaria ?? "#5CB572" }} />

                    <p>Reduza sua conta de energia com a Detronic.</p>

                    <div className="container-comecar">
                        <small>Sustentabilidade, liberdade e economia.</small>

                        <button type="button" style={data ? { backgroundColor: data?.plp_cor_principal } : {}} onClick={() => window.open(data ? `/onboarding?id_parceiro=${data?.id}` : `/onboarding`, "_self")}>
                            Começar a economizar
                        </button>
                    </div>
                </div>

                <div style={{ backgroundColor: "white" }}>
                    <img className="img-painel-solar" alt="Painel Solar" src="/images/painel-solar.png" />

                    <img className="img-painel-solar-mobile" alt="Painel Solar" src="/images/painel-solar-mobile.png" />

                    <p className="texto-escolha">Por que escolher a Detronic?</p>

                    <div className="container-solucoes">
                        <h2>Nós entregamos soluções personalizadas</h2>

                        <p style={{ marginBottom: "16px" }}>Somos a Detronic. Desde 2013, ajudamos os brasileiros a repensarem o consumo de energia. Tornamos acessível a energia renovável e mais barata para sua casa ou empresa, sem custo inicial.</p>

                        <ul>
                            <li>Economia garantida: reduza sua conta de luz em até 15% todo mês.</li>
                            <li>Adesão gratuita: sem custos para começar.</li>
                            <li>Sem obras: não é necessária nenhuma instalação.</li>
                            <li>Sustentabilidade: contribua para um planeta mais verde.</li>
                            <li>Liberdade total: tenha o poder de escolha de qual fonte de energia consumir.</li>
                        </ul>
                    </div>

                    <div className="video-solucoes">
                        <video ref={videoRef} controls={isPlaying} loop muted src="https://detronicenergia.com/wp-content/uploads/2022/12/Video-sem-titulo-%E2%80%90-Feito-com-o-Clipchamp.mp4" />

                        {!isPlaying && <img src="/images/play.svg" alt="Play" onClick={() => playVideo()} />}
                    </div>

                    <div className="container-futuro">
                        <p className="texto-futuro">Pense no futuro e economize</p>

                        <div className="container-detalhe-futuro">
                            <div>
                                <img className="img-futuro" src="/images/free.png" alt="Futuro" />

                                <h2>Custo zero de adesão</h2>

                                <p>Comece a economizar sem nenhum investimento inicial.</p>
                            </div>

                            <div>
                                <img className="img-futuro" src="/images/solar-energy.png" alt="Futuro" />

                                <h2>Energia solar sem instalação</h2>

                                <p>Desfrute dos benefícios da energia solar sem precisar instalar painéis no imóvel. Ideal para apartamentos, lojas e escritórios.</p>
                            </div>

                            <div>
                                <img className="img-futuro" src="/images/eco-home.png" alt="Futuro" />

                                <h2>Imóvel alugado? Sem problemas!</h2>

                                <p>Os créditos de economia são vinculados ao seu CPF ou CNPJ, independente do imóvel.</p>
                            </div>

                            <div>
                                <img className="img-futuro" src="/images/online-payment.png" alt="Futuro" />

                                <h2>Adesão sem burocracia</h2>

                                <p>Processo 100% online, fácil, seguro e rápido. Mais comodidade para você.</p>
                            </div>
                        </div>
                    </div>

                    <div className="container-passo-a-passo">
                        <h2>Passo-a-passo de como participar</h2>

                        <div className="passo-a-passo-numeracao">
                            <div className="bloco-passo-a-passo">
                                <span className="linha" />

                                <div className="circulo">
                                    <span style={data ? { backgroundColor: data?.plp_cor_principal_escura } : {}}>1</span>
                                </div>

                                <p>Cadastre-se em nossa plataforma: Insira os dados do titular e envie o PDF mais recente da sua conta de luz</p>
                            </div>

                            <div className="bloco-passo-a-passo">
                                <span className="linha" />

                                <div className="circulo">
                                    <span style={data ? { backgroundColor: data?.plp_cor_principal_escura } : {}}>2</span>
                                </div>

                                <p>Escolha seu plano e assine: Selecione a melhor solução para você e assine seu contrato digitalmente em minutos.</p>
                            </div>

                            <div className="bloco-passo-a-passo">
                                <span className="linha" />

                                <div className="circulo">
                                    <span style={data ? { backgroundColor: data?.plp_cor_principal_escura } : {}}>3</span>
                                </div>

                                <p>A energia das nossas fazendas solares na sua casa ou empresa: Transformamos a energia solar em energia elétrica e injetamos na rede da CEMIG.</p>
                            </div>

                            <div className="bloco-passo-a-passo">
                                <div className="circulo">
                                    <span style={data ? { backgroundColor: data?.plp_cor_principal_escura } : {}}>4</span>
                                </div>

                                <p>Você recebe os créditos na sua conta de luz: Com base no seu consumo, disponibilizamos créditos de energia que serão compensados diretamente na sua conta, gerando economia.</p>
                            </div>
                        </div>

                        <p className="texto-explicativo">Após adesão, você receberá o boleto da Detronic com seu consumo de energia com desconto e o boleto da CEMIG com as taxas mínimas obrigatórias. Ao somar os dois, você verá a economia gerada.</p>
                    </div>

                    <div className="container-luz-bem">
                        <div className="luz-bem">
                            <div>
                                <h2>Economize até 15% na conta de luz da sua casa ou da sua empresa, sem complicações.</h2>

                                <p>Sem obras, taxas ou fidelidade - tudo 100% digital!</p>
                            </div>

                            <div className="luz-bem-botoes">
                                <button type="button" onClick={() => window.open(data ? `/onboarding?id_parceiro=${data?.id}` : `/onboarding`, "_self")} style={data ? { backgroundColor: data?.plp_cor_secundaria } : {}} className="botao-aderir">
                                    Aderir agora
                                </button>
                            </div>
                        </div>

                        <div className="luz-bem">
                            <img src="/images/luz-do-bem.png" alt="Luz do Bem" className="img-luz-bem" />

                            <div>
                                <h2>Ao escolher o Luz do Bem, você doa 10% do valor da sua conta de energia para projetos sociais que realmente transformam vidas.</h2>

                                <p>Faça sua adesão e destine 10% da sua fatura Luz do Bem mensalmente a projetos sociais</p>
                            </div>

                            <div className="luz-bem-botoes">
                                <button type="button" onClick={() => window.open("https://detronicenergia.com/luz-do-bem", "_blank")} style={data ? { borderColor: data?.plp_cor_secundaria, color: data?.plp_cor_secundaria } : {}} className="botao-saber-mais">
                                    Saber mais
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="container-calculadora">
                        <div className="container-texto-calculadora">
                            <small className="texto-economia" style={data ? { color: data?.plp_cor_secundaria } : {}}>
                                Calcule agora o quanto você pode economizar
                            </small>

                            <p className="texto-consumo">Descubra agora quanto você pode economizar ao calcular sua economia</p>
                        </div>

                        <div>
                            <div className="calculadora" style={data ? { borderColor: data?.plp_cor_principal_clara } : {}}>
                                <div className="box-calculadora-texto">
                                    <small className="texto-consumo-descricao">Insira o valor médio da sua conta de luz:</small>

                                    <input className="input-calculadora" style={data ? { borderColor: data?.plp_cor_principal_clara } : {}} value={valor} onChange={(e) => valorDesconto(e)} />
                                </div>

                                <div className="economia" style={data ? { backgroundColor: data?.plp_cor_principal_clara } : {}}>
                                    <small className="texto-consumo-descricao">Veja sua economia:</small>

                                    <p className="valor-economia" style={data ? { color: data?.plp_cor_secundaria, overflowWrap: "break-word" } : { overflowWrap: "break-word" }}>
                                        {calculoFatura()}
                                    </p>
                                </div>
                            </div>

                            <p style={{ color: "#e1e4e8", marginTop: "10px" }} className="mb-0 tt-16">
                                *Valor aproximado, considerando os parâmetros: instalação bifásica e R$50,00 de iluminação pública.
                            </p>
                        </div>
                    </div>

                    <div className="container-agora" style={data ? { backgroundColor: data?.plp_cor_principal_escura } : {}}>
                        <h2>Escolha a energia que transforma: Sustentável, inspiradora e feita para você.</h2>

                        <div className="container-assinatura">
                            <p>Assine agora e em 60 a 90 dias comece a economizar na sua conta de luz.</p>

                            <button type="button" onClick={() => history.push(data ? `/onboarding?id_parceiro=${data?.id}` : `/onboarding`)} style={data ? { backgroundColor: data?.plp_cor_secundaria } : {}} className="botao-comecar-agora">
                                Começar agora
                            </button>
                        </div>
                    </div>

                    <FooterLandingPage data={data} />
                </div>
            </div>
        </BetterCircularProgress>
    );
}
